<template>

  <v-container fluid grid-list-md class="trip-wizard lookbook-container">

    <transition name="fade-up" mode="out-in" appear>
      <v-btn
        fixed
        fab
        :large="$vuetify.breakpoint.mdAndUp"
        color="primary"
        right
        @click="cartDialog = true"
        v-if="lookbookReady && selected && selected.length && showCartIcon"
        :style="{marginTop: ($vuetify.breakpoint.smAndDown ? '-50px' : '0px')}"
      >
        <v-badge
          color="grey darken-2"
          right
        >
          <template v-slot:badge>
            {{ selected.length }}
          </template>
          <v-icon
            color="white--text"
            :large="$vuetify.breakpoint.mdAndUp"
          >
            fas fa-suitcase
          </v-icon>
        </v-badge>
      </v-btn>
    </transition>

    <v-dialog
      v-model="requestMoreDialog"
      :persistent="requestMoreSubmitting"
      max-width="800"
      transition="fade"
    >
      <v-card color="white">
        <v-card-title class="primary white--text text-xs-center" style="position: relative;">
          <v-btn
            absolute
            small
            fab
            top
            right
            flat
            color="white"
            style="top: 10px;"
            :disabled="requestMoreSubmitting"
            @click="requestMoreDialog = false"
          ><v-icon>fas fa-times</v-icon></v-btn>
          <h3 style="margin: 0 auto;">Request Additional Items</h3>
        </v-card-title>
        <v-card-text class="inventoryDialogBody">
          <v-layout>
            <v-flex>
              <div class="field-label text-xs-center mb-3">Please provide feedback to help our stylists find you the right items</div>
              <v-textarea
                v-model="requestMoreNotes"
                placeholder="Type Here..."
                hide-details
                solo
                flat
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="primary white--text">
          <v-spacer></v-spacer>
          <v-btn color="primary white--text" @click="submitRequestMore()" :loading="requestMoreSubmitting">
            SUBMIT REQUEST
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="cartDialog"
      max-width="800"
      content-class="cartDialogContainer"
      scrollable
      transition="fade"
    >
      <v-card color="white">
        
        <v-card-title class="primary white--text text-xs-center" style="position: relative;">
          <v-btn
            absolute
            small
            fab
            top
            right
            flat
            color="white"
            style="top: 10px;"
            @click="cartDialog = false"
          ><v-icon>fas fa-times</v-icon></v-btn>
          <h3 style="margin: 0 auto;">Suitcase</h3>
        </v-card-title>
        <v-card-text class="inventoryDialogBody">
          <v-container grid-list-lg pa-0 ma-0>
            <v-layout row wrap v-if="selected">
              <v-flex 
                v-for="selItem in selected"
                :key="'idialog' + selItem.id"
                xs6
                sm4
                md3
                style="position: relative;"
              >
                <v-btn
                  absolute
                  top
                  right
                  fab
                  small
                  color="primary"
                  style="top: 0px; right: -4px;"
                  @click="toggleSelected(selItem.id)"
                >
                  <v-icon>fas fa-times</v-icon>
                </v-btn>
                <inventory-item :item="selItem" />
              </v-flex>
              <v-flex v-if="!selected || selected.length == 0" class="text-xs-center">
                Your shopping bag is empty
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="primary white--text">
          <v-spacer></v-spacer>
          <v-btn color="primary white--text" v-if="selected && selected.length" :disabled="checkoutLocked" @click="$emit('on-complete')">
            CHECKOUT
          </v-btn>
          <v-btn v-else color="primary white--text" @click="cartDialog = false">
            CLOSE
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="inventoryDialog"
      max-width="600"
      content-class="inventoryDialogContainer"
      scrollable
      transition="fade"
    >
      <v-card color="white">
        <v-card-title class="primary white--text text-xs-center" style="position: relative;">
          <v-btn
            absolute
            small
            fab
            top
            right
            flat
            color="white"
            style="top: 10px;"
            @click="inventoryDialog = false"
          ><v-icon>fas fa-times</v-icon></v-btn>
          <h3 style="margin: 0 auto;" v-html="(inventoryViewing.brand + ' ' + inventoryViewing.category) || '&nbsp;'"></h3>
        </v-card-title>
        <v-card-text class="inventoryDialogBody">
          <v-flex style="max-width: 450px; margin: 0 auto;">
            <inventory-item :item="inventoryViewing" detail />
          </v-flex>
        </v-card-text>
        <v-card-actions class="primary white--text">
          <v-spacer></v-spacer>
          <v-btn color="primary white--text" @click="toggleSelected()">
            <span v-if="inventoryViewing.selected">REMOVE FROM CART</span>
            <span v-else>ADD TO SUITCASE</span>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <transition name="fade-up" mode="out-in" appear>

      <v-layout v-if="!lookbookReady" justify-center align-center>
        <v-flex class="pb-0">

          <v-layout row wrap justify-center align-center class="mt-2" fill-height>
            <v-flex xs12 md10 pa-0 ma-0 style="border: 2px solid #000" fill-height>
              <v-layout row justify-center style="min-height: 250px;" ma-0 fill-height>
                <v-flex md6 class="lookbook-landing-hero" :style="{backgroundImage: 'url(' + cdn + 'lookbook_landing.jpg)'}">

                </v-flex>
                <v-flex md6 pa-5 my-4>
                  <h1>Your suitcase is in the packing queue...</h1>
                  <div class="my-4">Our stylists will personalize and send your lookbook for review <u>10 days before</u> your trip!</div>
                  <div class="my-4">We will send you an email notification when your lookbook is ready.</div>
                  <div class="my-4 caption">Please make sure to add us to your contacts</div>
                  <div class="mt-5 mb-3 text-xs-center"><v-btn color="primary" @click="newTrip()">BOOK ANOTHER TRIP</v-btn></div> 
                  <div class="my-1 text-xs-center"><router-link :to="{name: 'account-trips'}" style="text-decoration: none;">View my account</router-link></div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout v-else justify-center wrap>

        <v-flex class="pb-0" style="max-width: 900px;">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1 :style="{fontSize: ($vuetify.breakpoint.smAndDown ? '2em' : '3em')}">Welcome, {{ this.user.first_name }}! Here is your personally styled lookbook for your upcoming trip...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="">Please review your hand-selected items and choose 2 or more your trip</span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>

          <v-data-iterator
            :items="inventory"
            hide-actions
            content-tag="v-layout"
            content-class="wrap"
          >
            <template v-slot:item="props">
              <v-flex
                xs12
                md4
                lg3
              >
                <v-hover>
                  <v-card 
                    slot-scope="{ hover }"
                    flat
                    class="lookbook-item"
                    :class="{'item-hover':hover, 'item-selected':(props.item.selected ? true : false)}"
                    style="cursor: pointer;"
                    @click="openInventory(props.item.id, $event)"
                  >
                    <v-card-text>
                      <inventory-item :item="props.item" />
                    </v-card-text>
                    <v-card-text class="text-xs-center">
                      <v-btn color="primary" @click="toggleSelected(props.item.id)" class="noclick" :disabled="isUnavailable(props.item)">
                        <span class="noclick" v-if="props.item.selected">REMOVE FROM SUITCASE</span>
                        <span class="noclick" v-else>ADD TO SUITCASE</span>
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-flex>
            </template>
          </v-data-iterator>

        </v-flex>

        <v-flex xs12 class="text-xs-center mt-4" v-if="requestMore">
          <v-btn large color="primary" @click="requestMoreDialog = true">Request More</v-btn>
        </v-flex>

      </v-layout>

      
    </transition>
  </v-container>

</template>

<script>
import InventoryItem from '@/components/helpers/InventoryItem';

export default {
  props: {
    prefill: Object,
    requestMore: Boolean,
    order: Object,
    orderExpansion: String
  },
  components: {
    'inventory-item': InventoryItem
  },
  name: 'Lookbook',
  data () {
    return {
      inventoryDialog: false,
      inventoryViewing: {},
      cartDialog: false,
      showCartIcon: false,

      lookbook: (this.prefill ? this.prefill : {}),
      backupsSelected: [],

      requestMoreDialog: false,
      requestMoreSubmitting: false,
      requestMoreNotes: null

    }
  },
  mounted: function() {
    this.toggleWizardNextPrev();
    let ref = this;
    setTimeout(function() {
      ref.showCartIcon = true;
    },500);

    this.$store.commit('setWizardHasLookbook', (this.lookbook.status == 'READY' || this.lookbook.status == 'ADDITIONAL_REQUESTED'));
  },
  watch: {
    'totalSelected': function(newVal, oldVal) {
      this.toggleWizardNextPrev();
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    nextDisabled: function() {
      if(this.totalSelected < 2) return true;
      return false;
    },
    previousDisabled: function() {
      return false;
    },
    lookbookReady: function() {
      return (this.lookbook.status == 'READY' || this.lookbook.status == 'ADDITIONAL_REQUESTED');
    },
    checkoutLocked: function() {
      if(this.totalSelected < 2) return true;
      return false;
    },
    inventory: function() {
      let arr = [];
      if(!this.lookbook || !this.lookbook.lookbookInventory) return arr;

      for(let i = 0; i < this.lookbook.lookbookInventory.length; i++) {
        let inv_id = this.lookbook.lookbookInventory[i].inventory_id;
        let rec_id = this.lookbook.lookbookInventory[i].variation_rec_id;
        let sel_id = this.lookbook.lookbookInventory[i].variation_sel_id;
        for(let i2 = 0; i2 < this.lookbook.inventory.length; i2++) {
          let inv = JSON.parse(JSON.stringify(this.lookbook.inventory[i2]));
          if(this.lookbook.inventory[i2].id == inv_id) {
            inv.recommended = rec_id;
            inv.selected = sel_id;
            arr.push(inv);
          }
        }
      }
      return arr;
    },
    /*sortedInventory: function() {
      let arr = [];
      for(let i = 0; i < this.lookbook.inventory_id.length; i++) {
        let id = this.lookbook.inventory_id[i];
        for(let i2 = 0; i2 < this.lookbook.inventory_docs.length; i2++) {
          if(this.lookbook.inventory_docs[i2]._id == id) {
            arr.push(this.lookbook.inventory_docs[i2]);
            break;
          }
        }
      }

      return arr;
    },*/

    totalSelected: function() {
      let total = 0;
      if(!this.lookbook || !this.lookbook.lookbookInventory) return total;
      for(let i = 0; i < this.selected.length; i++) {
        let inv = this.selected[i];
        for(let i2 = 0; i2 < inv.variations.length; i2++) {
          if(inv.variations[i2].id == inv.selected) {
            if(inv.variations[i2].available && inv.variations[i2].stock_quantity > 0) total++;
          }
        }
      }
      return total;
    },
    selected: function() {
      let items = [];
      for(let i = 0; i < this.inventory.length; i++) {
        if(this.inventory[i].selected) items.push(this.inventory[i]);
      }
      return items;
    }
  },
  methods: {
    toggleWizardNextPrev: function() {
      this.$store.commit('setWizardNextDisabled', this.nextDisabled);
      this.$store.commit('setWizardPrevDisabled', this.previousDisabled);

      let remaining = 2;
      remaining -= this.totalSelected;
      if(remaining < 0) remaining = 0;
      this.$store.commit('setWizardItemsRemaining', remaining);
    },

    nextStep: function() {
      if(!this.nextDisabled) {
        this.$emit('on-complete');
      }
    },
    previousStep: function() {
      if(!this.previousDisabled) {
        let ref = this;
        this.showCartIcon = false;
        setTimeout(() => {
          ref.$emit('on-cancel');
        },200);
      }
    },
    isUnavailable: function(item) {
      if(item.selected) return false;
      for(let i = 0; i < item.variations.length; i++) {
        if(item.variations[i].id == item.recommended) {
          if(!item.variations[i].available || !item.variations[i].stock_quantity || item.variations[i].stock_quantity <= 0) return true;
        }
      }
      return false;
    },

    openInventory: function(id, e) {
      if(e.target.classList.contains('noclick')) return;

      this.inventoryViewing = this.findItemById(id);
      this.inventoryDialog = true;
      this.$nextTick(() => {        
        document.getElementsByClassName('inventoryDialogBody')[0].scrollTop = 0;
      });
    },

    toggleSelected: function(id) {
      if(typeof id === 'undefined') id = this.inventoryViewing.id;

      let selected = false;
      let sel_index = null;
      for(let i = 0; i < this.lookbook.lookbookInventory.length; i++) {
        if(this.lookbook.lookbookInventory[i].inventory_id == id) {
          sel_index = i;
          selected = (this.lookbook.lookbookInventory[i].variation_sel_id ? true : false);
        }
      }

      let inv_id = this.lookbook.lookbookInventory[sel_index].inventory_id;
      let var_rec_id = this.lookbook.lookbookInventory[sel_index].variation_rec_id;
      let var_sel_id = this.lookbook.lookbookInventory[sel_index].variation_sel_id;
      if( selected ) {
        this.$set(this.lookbook.lookbookInventory[sel_index], 'variation_sel_id', null);
        this.$http.delete('lookbooks/' + this.lookbook.id + '/select/' + inv_id)
          .catch(error => {
            this.$set(this.lookbook.lookbookInventory[sel_index], 'variation_sel_id', this.lookbook.lookbookInventory[sel_index].variation_rec_id);
            this.$swal.fire('Error', 'There was a problem removing this item from your suitcase');
          });

        if(this.order && this.order.id) {
          this.$http.post('orders/' + this.order.id + '/remove/' + var_rec_id + '?expand=' + this.orderExpansion)
            .then(response => {
              this.$emit('on-order-updated', response.data);
            })
            .catch(error => {});
        }
      } else {
        this.$set(this.lookbook.lookbookInventory[sel_index], 'variation_sel_id', this.lookbook.lookbookInventory[sel_index].variation_rec_id);
        this.$http.post('lookbooks/' + this.lookbook.id + '/select/' + inv_id + '/' + var_rec_id)
          .catch(error => {
            this.$set(this.lookbook.lookbookInventory[sel_index], 'variation_sel_id', null);
            this.$swal.fire('Error', 'There was a problem adding this item to your suitcase');
          });

        if(this.order && this.order.id) {
          this.$http.post('orders/' + this.order.id + '/add/' + var_rec_id + '?expand=' + this.orderExpansion)
            .then(response => {
              this.$emit('on-order-updated', response.data);
            })
            .catch(error => {});
        }
      }
      this.inventoryDialog = false;

      

      //this.$http.patch('lookbooks/' + this.lookbook._id, {user_selected: this.lookbook.user_selected});
      this.$emit('on-update', this.lookbook);
    },

    findItemById: function(id) {
      for(let item of this.inventory) {
        if(item.id == id) return item;
      }
      return {};
    },

    newTrip: function() {
      if(this.$route.params.id == 'new') {
        this.$emit('on-new-trip');
      } else {
        this.$router.push({name: 'trip', params: {id: 'new'}});
      }
    },

    submitRequestMore: function() {
      this.requestMoreSubmitting = true;
      let params = {
        notes: this.requestMoreNotes
      }
      this.$http.post('lookbooks/' + this.lookbook.id + '/request-more', params)
        .then(response => {
          this.$set(this.lookbook, 'status', 'ADDITIONAL_REQUESTED');
          this.$emit('on-update', this.lookbook);


          this.requestMoreNotes = null;
          this.requestMoreDialog = false;
          this.$swal.fire('Request Received', 'Your request for additional items has been received. You will receive a notification once your Lookbook is updated.');
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was a problem submitting your request. Please try again.');
        })
        .finally(() => {
          this.requestMoreSubmitting = false;
        });
    }
    
  }
}
</script>

<style lang="scss">
  .inventoryDialogContainer {
    img {
      max-height: 450px;
      max-width: 100%;
    }
  }
  .cartDialogContainer {
    img {
      max-width: 100%;
    }
  }
</style>